<template>
  <v-dialog @keydown.esc="open=false" v-model="open" persistent max-width="600px" class="custom-dialog">
    <v-card>
      <div class="d-flex justify-end">
        <v-btn
          fab
          color="transparent"
          depressed
          @click="closeUploadDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <vue-dropzone
          ref="myVueDropzone"
          id="dropzone"
          :options="{ ...defaultDropzoneOptions, ...dropzoneOptions }"
          useCustomSlot
          v-bind="dropzoneProps"
          @vdropzone-success="handleFile"
        >
          <div class="dz-message" data-dz-message>
            <span>{{ $t('components.uploadFileDialog.dropzoneText') }} en formato {{ dropzoneOptions.acceptedFiles || defaultDropzoneOptions.acceptedFiles }}</span>
          </div>
        </vue-dropzone>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <Button type="secondary" size="regular" @click="closeUploadDialog()">
          {{ $t('components.uploadFileDialog.buttonClose') }}
        </Button>
        <Button :disabled="!file" size="regular" @click="uploadFile()">
          {{ $t('components.uploadFileDialog.buttonUpload') }}
        </Button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import Button from '@/components/elements/Button'

export default {
  name: 'UploadFileDialog',
  props: {
    dropzoneProps: {
      type: Object,
      default: function () {
        return {}
      }
    },
    dropzoneOptions: {
      default: function () {
        return {}
      },
      type: Object
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    Button
  },
  data () {
    return {
      open: false,
      defaultDropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        maxFiles: 1,
        acceptedFiles: '.xls, .xlsx',
        dictDefaultMessage: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictDefaultMessage'),
        dictFallbackMessage: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictFallbackMessage'),
        dictFallbackText: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictFallbackText'),
        dictFileTooBig: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictFileTooBig'),
        dictInvalidFileType: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictInvalidFileType'),
        dictResponseError: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictResponseError'),
        dictCancelUpload: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictCancelUpload'),
        dictCancelUploadConfirmation: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictCancelUploadConfirmation'),
        dictRemoveFile: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictRemoveFile'),
        dictMaxFilesExceeded: this.$i18n.t('components.uploadFileDialog.dropzoneOptions.dictMaxFilesExceeded')
      },
      file: null
    }
  },
  methods: {
    openUploadDialog () {
      this.open = true
    },
    closeUploadDialog () {
      this.open = false
      this.file = null
      this.$refs.myVueDropzone.removeAllFiles(true)
    },
    handleFile (file, res) {
      this.file = file
    },
    uploadFile () {
      this.$emit('uploadFile', this.file)
    }
  }
}
</script>

<style>
  .custom-dialog .v-dialog .v-card {
    border-style: dashed;
  }
</style>
